module.exports = __webpack_public_path__ + "static/img/999.b2c7465d.png";